 import React, { useId, useRef, useEffect, useState } from "react";
 import { Helmet } from "react-helmet-async";
 import { styled } from "@mui/material/styles";
 import {
   Typography,
   Card,
   Stack,
   Box,
   TextField,
   FormGroup,
   FormControlLabel,
   Checkbox,
   Button,
   ButtonBase,
   Popover, 
 } from "@mui/material";
 import { useAuth0 } from "@auth0/auth0-react";
 import SignUpBackground from "src/public/assets/illustrations/signupBackground.png";
 import LeftSideImage from "src/public/assets/illustrations/leftSide.png";
 import RightSideImage from "src/public/assets/illustrations/rightSide.svg";
 import InputField from './InputField.js'
 import TermsAndConditions from "./TermsAndConditions.js";

 


 export default function SignUpForm({handleSubmit,
submitTick,
errors,
setErrors,
validate,
showErrors,
setShowErrors,
firstName,
setFirstName,
lastName,
setLastName,
email,
setEmail,
password,
setPassword,
confirmPassword,
setConfirmPassword,
handleFirstNameChange,
handleLastNameChange,
handleEmailChange,
handlePasswordChange,
handleConfirmPasswordChange,
showPassword,
setShowPassword,
showConfirmPassword,
setShowConfirmPassword,
handleTogglePassword,
handleToggleConfirmPassword, termsAccepted, setTermsAccepted, handleTermsAcceptedChange}) {


    const auth0LoginUrl =
  "https://dev-4m53d4wv8p6pmod8.us.auth0.com/u/login";


    const handleSignIn = () => {
    window.location.href = auth0LoginUrl;
  };


    const [showTerms, setShowTerms] = useState(false);



    const handleTermsClick = () => {
    setShowTerms(true);
  }


  const handleTermsClose = () => {
    setShowTerms(false);
  };

  



    return (

 <>
 {/* First & Last Name */}
              <Stack direction="row" spacing={2.5} sx={{ width: "100%", mb: 2.5, mt: 5 }}>
                <Stack sx={{ flex: 1 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mb: 0.5,
                      fontFamily: "'Lato', sans-serif",
                      color: "#49768C",
                    }}
                  >
                    First Name
                  </Typography>
                 <InputField
  name="firstName"
  label="First Name"
  value={firstName}
  onChange={handleFirstNameChange}
  errorMsg={showErrors ? errors.firstName : undefined}
  submitTick={submitTick}
/>
                </Stack>
                <Stack sx={{ flex: 1 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mb: 0.5,
                      fontFamily: "'Lato', sans-serif",
                      color: "#49768C",
                    }}
                  >
                    Last Name
                  </Typography>
                                  <InputField
 name="lastName"
  value={lastName}
  onChange={handleLastNameChange}
  errorMsg={showErrors ? errors.lastName : undefined}
    submitTick={submitTick}

/>
                </Stack>
              </Stack>

              {/* Email, Password, Confirm Password */}
              <Stack direction="column" spacing={2.5} sx={{ width: "100%" }}>
                <Stack>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mb: 0.5,
                      fontFamily: "'Lato', sans-serif",
                      color: "#49768C",
                    }}
                  >
                    Email
                  </Typography>
                                                  <InputField
 name="email"
  value={email}
  onChange={handleEmailChange}
  errorMsg={showErrors ? errors.email : undefined}
    submitTick={submitTick}
      isPasswordField={Boolean.true}

/>
                </Stack>

                <Stack>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mb: 0.5,
                      fontFamily: "'Lato', sans-serif",
                      color: "#49768C",
                    }}
                  >
                    Password
                  </Typography>
                                                                <InputField
 name="password"
  value={password}
  onChange={handlePasswordChange}
  errorMsg={showErrors ? errors.password : undefined}
    submitTick={submitTick}
                    showPassword={showPassword}
                                    onClick={handleTogglePassword}
                                    isPasswordField



/>
                </Stack>

                <Stack>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      mb: 0.5,
                      fontFamily: "'Lato', sans-serif",
                      color: "#49768C",
                    }}
                  >
                    Confirm Password
                  </Typography>
                                                                  <InputField
 name="confirmPassword"
  value={confirmPassword}
  onChange={handleConfirmPasswordChange}
  errorMsg={showErrors ? errors.confirmPassword : undefined}
    submitTick={submitTick}
   
     showPassword={showConfirmPassword}
                                    onClick={handleToggleConfirmPassword}
                                    isPasswordField

/>
                </Stack>

                {/* Terms & Policy */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    alignItems: "center",
                    mt: "12px",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                      onClick={handleTermsAcceptedChange}
                        sx={{
                          mr: -1.5,
                          color: errors.termsAccepted ? "#AA5869" : "#C5D3DD", // unchecked color (border)  
                          "&.Mui-checked": {
                            color: "#B4CEE1", // checkmark + filled color when checked
                          },
                        }}
                      />
                    }
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontFamily: "'Lato', sans-serif",
                      fontWeight: 600,
                      pr: "4px",
                      color: "#49768C",
                    }}
                  >
                    I Agree To
                  </Typography>
                  <Typography
                    onClick={handleTermsClick}
                    variant="subtitle1"
                    sx={{
                      fontFamily: "'Lato', sans-serif",
                      fontWeight: 600,
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "#49768C",
                    }}
                  >
                    Terms & Policy
                  </Typography>
                </Box>

                {/* Sign Up Button */}
                <Button
                onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    fontFamily: "'Lato', sans-serif",
                    mt: "40px",
                    height: "59px",
                    backgroundColor: "#FF9490",
                    fontSize: 22,
                    fontWeight: 600,
                    color: "#fff",
                    textTransform: "none",
                    boxShadow: "6px 9px 19.1px rgba(255, 148, 144, 0.3)",
                    borderRadius: "11px",
                    "&:hover": {
                      backgroundColor: "#FF7A7A",
                      boxShadow: "6px 9px 19.1px rgba(255, 122, 122, 0.35)",
                    },
                    "&:active": {
                      backgroundColor: "#FF5F5F",
                      boxShadow: "6px 9px 19.1px rgba(255, 95, 95, 0.4)",
                    },
                    "&:focus": {
                      backgroundColor: "#FF9490",
                      boxShadow: "6px 9px 19.1px rgba(255, 148, 144, 0.5)",
                    },
                  }}
                >
                  Sign Up
                </Button>

                {/* Already have account */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    alignItems: "center",
                    pb: 4.5,
                    pt: 0.5,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "'Lato', sans-serif",
                      fontWeight: 500,
                      pr: "10px",
                      color: "#395465",
                    }}
                  >
                    Already have an account?
                  </Typography>
                  <ButtonBase
                  onClick={handleSignIn}
                  >
                    <Typography
                      sx={{
                        fontFamily: "'Lato', sans-serif",
                        fontWeight: 900,
                        color: "#49768C",
                        cursor: "pointer",
                      }}
                    >
                      Sign In
                    </Typography>
                  </ButtonBase>
                </Box>
                <TermsAndConditions
                  open={showTerms}
                  onClose={handleTermsClose}
                />
              </Stack>
              </>


  );
}
